import OtherNews from './OtherNews'

export default OtherNews
